export default "__VITE_ASSET__DRq56BiT__"